<script setup lang="ts">
  import Button from "primevue/button";
  import { useFieldArray } from "vee-validate";
  import ServiceBlock from "./service-block.vue";

  const { fields, push, remove } = useFieldArray<{
    service: string;
    products: string[];
  }>("services");
</script>

<template>
  <div class="flex flex-col gap-4 items-start">
    <service-block class="w-full" v-for="(service, idx) in fields" :key="service.key" :idx="idx" :removeable="fields.length > 1" @remove="remove(idx)" />
    <Button class="w-fit" icon="pi pi-plus" label="Dienst" text @click="push({ service: '', products: [] })" />
  </div>
</template>
